import { format, parseISO } from 'date-fns';

export const formatAppointmentDate = (dateStr: string) =>
  format(parseISO(dateStr), 'dd MMM yyyy');

export const formatDateTime = (dateStr: string | null | undefined) => {
  if (!dateStr) return '–';
  return format(parseISO(dateStr), 'dd MMM, hh:mm aa');
};

export const formatTimeOnly = (dateStr: string | null | undefined) => {
  if (!dateStr) return '–';
  return format(parseISO(dateStr), 'hh:mm aa');
};

export const calcDuration = (start: string | null | undefined, end: string | null | undefined) => {
  if (!start || !end) return '–';
  const mins = Math.round(
    (new Date(end).getTime() - new Date(start).getTime()) / 60000
  );
  return `${mins} min`;
};
